import React, { createContext, useReducer } from "react";

const createDataContext = (reducer, actions, defaultValue, component) => {
  const Context = createContext();
  const Provider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, defaultValue);

    const boundActions = {};
    for (let key in actions) {
      boundActions[key] = actions[key](dispatch);
    }

    return (
      <Context.Provider value={{ state, ...boundActions }}>
        {component ? component : null}
        {children}
      </Context.Provider>
    );
  };
  return { Provider, Context };
};

export default createDataContext;
